import React from 'react';
import { Input } from 'antd';
import { PasswordProps as PasswordCopyProps } from 'antd/lib/input/Password';

export type PasswordProps = PasswordCopyProps;

const ProInputPassword: React.FC<PasswordProps> = React.forwardRef<
  any,
  PasswordProps
>((props, ref) => {
  const { children, ...resProps } = props;
  return (
    <Input.Password ref={ref} {...resProps}>
      {children}
    </Input.Password>
  );
});

export default ProInputPassword;
